// extracted by mini-css-extract-plugin
export default {"container-000":"AntSpin_container-000__WGf8m","message-000":"AntSpin_message-000__dfhJs"};